module.exports = __webpack_public_path__ + "img/stack08.a252fc3b.svg";